"use strict";

var PropTypes = require("prop-types");

var React = require("react");

var AccountConstants = require("../accountComponents/AccountConstants");

var HtmlHelper = require("../shared/HtmlHelper");

class PaymentTypeSelector extends React.Component {
	constructor(props) {
		super(props);

		// Set the initial selected payment type, either from the "Default Payment Type Selected" property or the first element if there is no default or the default does not exist
		var defaultSelectedIndex = props.supportedPaymentTypes.indexOf(props.defaultPaymentTypeSelected);
		if (defaultSelectedIndex < 0) {
			defaultSelectedIndex = 0;
		}
		var selectedType = props.supportedPaymentTypes && props.supportedPaymentTypes.length > 0 ? props.supportedPaymentTypes[defaultSelectedIndex] : null;

		var uniqueName = "";
		//There can be more than one PaymentTypeSelector.
		//	They need different input names so that they are not all tied together.
		if (props.dataRepeatedId) {
			uniqueName = HtmlHelper.getId($("body"));
		} else {
			uniqueName = props.id || props.dataNestedId || "";
		}

		if (uniqueName) {
			uniqueName = `_${uniqueName}`;
		}

		this.state = {
			selectedType,
			uniqueName
		};

		this._onChange = this._onChange.bind(this);
	}

	handleTypeSelected(event) {
		var selectedType = event.currentTarget.value;

		this.updateDisplay(selectedType);

		this.setState({ selectedType });
		AccountActions.setSelectedPaymentType(this.state.uniqueName, selectedType);
	}

	updateDisplay(selectedType) {
		//It is done this way mainly for the designer because there can be multiple PaymentTypeSelectors because of the accountState component.
		//	On the constituent-side, there should only be a single PaymentTypeSelector component.
		var $thisDOMNode = $(ReactDOM.findDOMNode(this));
		$thisDOMNode.parents("[data-component='paymentType']").find(".paymentInformation").css("display", "");
		$thisDOMNode.parents("[data-component='paymentType']").find(`.paymentInformation[data-payment-type="${selectedType}"]`).css("display", "block");
	}

	_onChange() {
		if (this._isMounted) {
			var selectedType = AccountActions.getSelectedPaymentType(this.state.uniqueName);
			if (selectedType) {
				this.setState({
					selectedType
				});

				this.updateDisplay(selectedType);
			}
		}
	}

	componentDidMount() {
		this._isMounted = true;

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}

		//It is done this way mainly for the designer because there can be multiple PaymentTypeSelectors because of the accountState component.
		//	On the constituent-side, there should only be a single PaymentTypeSelector component.
		var $thisDOMNode = $(ReactDOM.findDOMNode(this));
		$thisDOMNode.parents("[data-component='paymentType']").find(".paymentInformation").css("display", "");
		$thisDOMNode.parents("[data-component='paymentType']").find(`.paymentInformation[data-payment-type="${this.state.selectedType}"]`).css("display", "block");

		this._onChange();
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_PAYMENT_TYPE, this._onChange);
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
		}
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_PAYMENT_TYPE, this._onChange);

		this._isMounted = false;
	}

	render() {
		var supportedPaymentTypes = this.props.supportedPaymentTypes;
		var selectedType = this.state.selectedType;

		return (
			<div
				data-react-component-name="PaymentTypeSelector"
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf || "paymentType"}
			>
				{supportedPaymentTypes && supportedPaymentTypes.length > 1 && supportedPaymentTypes.map((paymentType, index) => {
					return (
						<label key={paymentType} data-component="PaymentTypeSelector.label" className={HtmlHelper.safeClassName(paymentType)} >
							<input type="radio" name={`paymentType${this.state.uniqueName}`} value={paymentType} onChange={this.handleTypeSelected.bind(this)} checked={paymentType === selectedType} />
							<span data-component="PaymentTypeSelector.label.span">{paymentType}</span>
						</label>
					);
				})}
				{this.props.isDesignMode && (!supportedPaymentTypes || supportedPaymentTypes.length <= 1) &&
					<div className="collapsedComponentPlaceholder">Payment Type Selector</div>
				}
			</div>
		);
	}
}

PaymentTypeSelector.defaultProps = {
	theme: "0"
};

PaymentTypeSelector.propTypes = {
	supportedPaymentTypes: PropTypes.array,
	theme: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string
};

module.exports = PaymentTypeSelector;

